import React from 'react';
import { observer } from 'mobx-react';
import { Trans } from 'react-i18next';
import { Tooltip, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { PoweroffOutlined } from '@ant-design/icons';
import Avatar from '../../../../Base/User/Avatar';
import { USER_STATES } from '../../../../../constants';
import { useStore } from '../../../../../store/rootStore';
import NotificationDropdown from '../../../../Notifications/layout/Dropdown';
import placeholderAvatar from '../../../../../assets/avatars/placeholder-avatar.png';
import styles from './AccountSection.module.scss';
const AccountSection = ({ userName }) => {
    const { loginStore, statusStore } = useStore();
    const history = useHistory();
    const logOut = (event) => {
        event.preventDefault();
        console.log('LOGOUT');
        loginStore
            .logOut()
            .then(() => {
            if (loginStore.userState === USER_STATES.LOGGED_OUT) {
                history.push('/login');
            }
        })
            .catch((error) => {
            console.error('Error logging out', error);
        });
    };
    return (React.createElement("div", { className: styles.accountSection },
        React.createElement("div", { className: styles.section },
            React.createElement(Avatar, { displayName: userName, src: placeholderAvatar, status: statusStore.status }),
            React.createElement("div", { className: styles.accountSectionUser },
                React.createElement("div", null, userName))),
        React.createElement("div", { className: styles.section },
            React.createElement(NotificationDropdown, null),
            React.createElement(Tooltip, { placement: "bottomRight", title: React.createElement(Trans, { i18nKey: "logout" }) },
                React.createElement(Button, { shape: "circle", className: styles.logoutButtonCircle, onClick: logOut },
                    React.createElement(PoweroffOutlined, { className: styles.accountSectionLogout }))))));
};
export default observer(AccountSection);
